import { defineStore } from 'pinia'
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useShortcut } from '@nsftx/seven-nxg-retail-vue-sdk'

export const useSlipCheckStore = defineStore('slipCheckStore', () => {
  const route = useRoute()
  const slipId = ref('')
  const isSlipCheckFormOpened = ref(false)
  const isSlipCheckDetailsOpened = ref(false)

  useShortcut('OPEN_TICKET_CHECK', () => {
    showSlipCheckModal()
  })

  const showSlipCheckModal = () => {
    slipId.value = '' // every time we open slip check modal, reset slip id
    isSlipCheckFormOpened.value = true
  }

  const closeSlipCheckModal = () => {
    isSlipCheckFormOpened.value = false
  }

  const showSlipCheckDetailsModal = () => {
    isSlipCheckDetailsOpened.value = true
  }

  const closeSlipCheckDetailsModal = () => {
    isSlipCheckDetailsOpened.value = false
  }

  watch(
    () => route.fullPath,
    () => {
      closeSlipCheckModal()
      closeSlipCheckDetailsModal()
    },
  )

  return {
    slipId,
    isSlipCheckFormOpened,
    isSlipCheckDetailsOpened,
    showSlipCheckModal,
    closeSlipCheckModal,
    showSlipCheckDetailsModal,
    closeSlipCheckDetailsModal,
  }
})
